export const bigTablet = '@media (max-width: 862px)'

export const tablet = '@media (max-width: 768px)'

export const mobile = '@media (max-width: 500px)'

export const iphoneSe = '@media (max-width: 375px)'

